import RestApi from './../../api/rest-api-client'

const srvcEndpoint = '/university_payments'

export default {
  /**
   * Get the current deposit amount from system settings
   */
  getDepositAmount: async opts => RestApi.request('GET', srvcEndpoint + '/deposit-amount', null, opts),

  /**
   * Create a Stripe checkout session for university deposit
   * @param {number} enrollmentId - The enrollment ID to pay for
   */
  createCheckoutSession: async (enrollmentId, opts) =>
    RestApi.request('POST', srvcEndpoint + '/create-checkout-session', { enrollment_id: enrollmentId }, opts),

  /**
   * Verify payment status by checking Stripe directly
   * Used as fallback when webhooks don't arrive (e.g., local development)
   * @param {number} enrollmentId - The enrollment ID to verify
   */
  verifyPayment: async (enrollmentId, sessionId, opts) =>
    RestApi.request(
      'POST',
      srvcEndpoint + '/verify-payment',
      { enrollment_id: enrollmentId, session_id: sessionId },
      opts
    ),

  /**
   * Process a refund for an enrollment (admin only)
   * @param {number} enrollmentId - The enrollment ID to refund
   */
  refund: async (enrollmentId, opts) => RestApi.request('POST', srvcEndpoint + `/refund/${enrollmentId}`, null, opts),
}
